import { Select } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import type User from 'stores/User';
import { isSiteRole, SITE_ROLE_LABELS, SITE_ROLE_ORDER } from 'types/Roles';

const StyledSelect = styled(Select)`
  width: 110px;
`;

export interface RoleSelectProps {
  store: User;
}

function RoleSelect({ store }: RoleSelectProps) {
  return (
    <div data-testid="RoleSelect">
      <StyledSelect
        id={store.id}
        onSelect={(value) => {
          if (isSiteRole(value)) store.setRole(value);
        }}
        value={store.role}
        options={SITE_ROLE_ORDER.map((role) => ({
          value: role,
          label: SITE_ROLE_LABELS[role],
        }))}
      />
    </div>
  );
}

export default observer(RoleSelect);
